import { z } from 'zod';

/**
 * ElevenLabs raw metadata schema - matches the response from ElevenLabs STT API
 * Note: ElevenLabs API uses camelCase for field names
 */
export const elevenlabsRawMetadataSchema = z.object({
  languageCode: z.string().optional(),
  languageProbability: z.number().optional(),
  text: z.string().optional(),
  words: z
    .array(
      z.object({
        text: z.string(),
        start: z.number(),
        end: z.number(),
        type: z.enum(['word', 'spacing', 'audio_event']).optional(),
        speakerId: z.string().optional(),
        logprob: z.number().optional(),
      }),
    )
    .optional(),
});

export type ElevenLabsRawMetadata = z.infer<typeof elevenlabsRawMetadataSchema>;
